export const GET_FILES_LIST_DESKTOP = 'GET_FILES_LIST_DESKTOP';
export const GET_FILES_LIST_MOBILE = 'GET_FILES_LIST_MOBILE';
export const GET_FILES_LIST_TABLET = 'GET_FILES_LIST_TABLET';
export const SET_FILES_TO_FILES_LIST_TABLET = 'SET_FILES_TO_FILES_LIST_TABLET';
export const ADD_FILE_TO_FILES_LIST_DESKTOP = 'ADD_FILE_TO_FILES_LIST_DESKTOP';
export const SELECT_FILE_BY_FILE_ID = 'SELECT_FILE_BY_FILE_ID';
export const EDIT_SELECTED_FILE_BY_FILE_ID = 'EDIT_SELECTED_FILE_BY_FILE_ID';
export const DELETE_FILE_BY_FILE_ID = 'DELETE_FILE_BY_FILE_ID';
